// extracted by css-extract-rspack-plugin
export default {"container":"gWpux6kEvs0LN8Ml","zoomDisabled":"t6ADDlBBerM0YKLg"};